export default __webpack_public_path__ + "static/CL-1-7c4110db745ff250783628e19ba8ae37.png";